import bind from 'bind-decorator';
import View from '@/views/view';

export default class FabricNode extends View {
  initialize(map, initialFabricData) {
    this.fabricNode = null;
    this.initialFabricData = initialFabricData;
    this.map = map;
    this.canvasScaleRatio = 1.0;
  }

  get canvas() {
    return this.map.canvas;
  }

  get defaultFabricOptions() {
    return {
      borderColor: '#00bb00',
      cornerColor: '#00bb00',
      cornerSize: 8,
      cornerStyle: 'rect',
      transparentCorners: false,
      editable: this.isEditable,
      selectable: this.isSelectable,
      lockScalingFlip: true
    };
  }

  get isEditable() {
    return this.map.isEditable;
  }

  get isSelectable() {
    return this.map.isEditable;
  }

  data() {
    if (!this.fabricNode) {
      return this._parseData();
    }

    return {
      angle: this.fabricNode.angle.round(3),
      left: this.map.descaleX(this.fabricNode.left).round(3),
      top: this.map.descaleY(this.fabricNode.top).round(3),
      scaleX: this.fabricNode.scaleX,
      scaleY: this.fabricNode.scaleY
    };
  }

  _parseData(data = this.initialFabricData || this.$node.data('fabric_data')) {
    return {
      left: parseFloat(data.left) || 0.0,
      top: parseFloat(data.top) || 0.0,
      angle: parseFloat(data.angle) || 0.0,
      scaleX: parseFloat(data.scaleX) || 1,
      scaleY: parseFloat(data.scaleY) || 1
    };
  }

  _bindInputs() {
    this.$('input').on('focus', () => this.map.select(this, true));
    this.$('input[data-field]').on('change keyup', ({ currentTarget }) => (
      this._onInputChange(currentTarget)
    ));
  }

  @bind
  _syncFabricNode(event, data = this.data()) {
    this.fabricNode.set({
      angle: data.angle,
      left: this.map.scaleX(data.left),
      top: this.map.scaleY(data.top),
      scaleX: data.scaleX * this.canvasScaleRatio,
      scaleY: data.scaleY * this.canvasScaleRatio
    });
    this.fabricNode.setCoords();
    this.canvas.requestRenderAll();
  }

  _syncInputs(data = this.data()) {
    this.$left ||= this.$node.find('[data-field=left]');
    this.$top ||= this.$node.find('[data-field=top]');
    this.$angle ||= this.$node.find('[data-field=angle]');
    this.$scaleX ||= this.$node.find('[data-field=scaleX]');
    this.$scaleY ||= this.$node.find('[data-field=scaleY]');

    this.$left.val(data.left);
    this.$top.val(data.top);
    this.$angle.val(data.angle);
    this.$scaleX.val(data.scaleX / this.canvasScaleRatio);
    this.$scaleY.val(data.scaleY / this.canvasScaleRatio);
  }

  _onInputChange(currentTarget) {
    const value = parseFloat(currentTarget.value);
    const field = $(currentTarget).data('field');

    if (!Number.isNaN(value)) {
      if (field === 'width' || field === 'left') {
        this.fabricNode.set(field, this.map.scaleX(value));
      } else if (field === 'height' || field === 'top') {
        this.fabricNode.set(field, this.map.scaleY(value));
      } else if (field === 'scaleX' || field === 'scaleY') {
        this.fabricNode.set(field, value * this.canvasScaleRatio);
      } else {
        this.fabricNode.set(field, value);
      }

      this.canvas.requestRenderAll();
    }
  }
}
